import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import localeEn from '@angular/common/locales/en';
import localeSe from '@angular/common/locales/sv';
import { Component, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { Angulartics2Piwik } from 'angulartics2/piwik';
import moment from 'moment';
import { ComponentsHelper } from 'ng2-bootstrap/components/utils/components-helper.service';
import { filter } from 'rxjs/operators';
import { ApiClientService } from './shared/api-client.service';
import { AppState } from './shared/app.state';
import { FeatureFlipperService } from './shared/feature-flipper.service';

const featureFlipper = new FeatureFlipperService();

@Component({
  selector: 'app-root',
  encapsulation: ViewEncapsulation.None,
  styleUrls: [
    'style/global.scss',
    'style/dashboards.scss',
    'style/hessen.scss',
  ],
  providers: [ApiClientService, FeatureFlipperService],
  templateUrl: 'app.template.html',
})
export class AppComponent {
  routerLoading: boolean = true;

  constructor(
    private store: Store,
    public translate: TranslateService,
    private componentsHelper: ComponentsHelper,
    private vcr: ViewContainerRef,
    private router: Router,
    private angulartics2Piwik: Angulartics2Piwik,
    private featureFlipper: FeatureFlipperService
  ) {
    translate.addLangs(['en', 'sv', 'de']);
    translate.setDefaultLang('en');

    const browserLang = translate.getBrowserLang();
    store.select(AppState).subscribe((state) => {
      let language;
      language =
        state && state.language
          ? state.language
          : browserLang.match(/en|sv|de/)
          ? browserLang
          : 'en';
      translate.use(language);
      moment.locale(language);
      switch (language) {
        case 'sv':
          registerLocaleData(localeSe, 'sv');
          break;
        case 'de':
          registerLocaleData(localeDe, 'de');
          break;
        case 'en':
        default:
          registerLocaleData(localeEn, 'en');
      }
    });

    document.body.classList.add('dashboards');

    if (featureFlipper.enabled('hessen_demo'))
      document.body.classList.add('hessen');

    angulartics2Piwik.startTracking();

    componentsHelper.setRootViewContainerRef(vcr);

    router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.routerLoading = false;
        if (typeof (<any>window).Intercom !== 'undefined')
          (<any>window).Intercom('update');
      });
  }
}
